import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getLogsList = createAsyncThunk(
  "get-logs",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("account-log/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLogsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLogsList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.logList?? [];
        state.perPage = action?.payload?.data?.data?.perPage?? 1;
        state.total = action?.payload?.data?.data?.total?? 0;
      })
      .addCase(getLogsList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default logsSlice.reducer;
